// Pure helpers for Site Progress progress notes (backend: common/site_notes.py).
import { shortDate } from './siteShareModel';

export const MAX_NOTE = 2000;

// "Edited Oct 18, 2026" from the note's last-edit time; '' when unknown.
export function editedLine(note) {
  const d = note && shortDate(note.updated_at);
  return d ? `Edited ${d}` : '';
}

// Characters left, shown once the writer is close to the cap.
export function charsLeft(text) {
  return MAX_NOTE - String(text || '').length;
}

export function showCounter(text) {
  return charsLeft(text) <= 200;
}

// Same cleanup the API does, so Save is disabled for whitespace-only edits.
export function cleanNote(text) {
  return String(text || '').replace(/\r\n?/g, '\n').split('\n').map((l) => l.trimEnd()).join('\n').replace(/\n{3,}/g, '\n\n').trim();
}

export function noteChanged(note, draft) {
  return cleanNote(draft) !== ((note && note.text) || '');
}
